import { observer } from "mobx-react";
import React from "react";
import {
    DatePickerComponentStore,
    DateReferenceOption,
    InteractionDateReferenceOption,
} from "../../../../stores/ComponentStores/DatePickerComponentStore";
import AcxSelectSingle from "../../Select/BaseSelectComponents/AcxSelectSingle";

interface IDateTypeSelectorProps {
    datePickerStore: DatePickerComponentStore;
    dateReferenceOptions?:
        | DateReferenceOption[]
        | InteractionDateReferenceOption[];
    disabled?: boolean;
    menuPortalTarget?: HTMLElement | null | undefined;
    onChange?(dateType: string): void;
    useCustomIds?: boolean;
}

const AcxDateTypeSelector: React.FC<IDateTypeSelectorProps> = observer(
    ({
        datePickerStore,
        dateReferenceOptions = Object.values(DateReferenceOption),
        disabled,
        onChange,
        menuPortalTarget,
        useCustomIds,
    }) => {
        const dropDownOptions = React.useMemo(() => {
            return {
                [DateReferenceOption.ArrivalDate]: {
                    label: "Arrival Date",
                    value: DateReferenceOption.ArrivalDate,
                },
                [DateReferenceOption.InteractionDate]: {
                    label: "Interaction Date",
                    value: DateReferenceOption.InteractionDate,
                    id: useCustomIds
                        ? "agents-date-type-interaction-date"
                        : undefined,
                },
                [DateReferenceOption.EvaluationCompleteDate]: {
                    label: "Evaluation Complete Date",
                    value: DateReferenceOption.EvaluationCompleteDate,
                    id: useCustomIds
                        ? "agents-date-type-evaluation-complete-date"
                        : undefined,
                },
                [InteractionDateReferenceOption.EvaluationModifiedDate]: {
                    label: "Evaluation Modified Date",
                    value: InteractionDateReferenceOption.EvaluationModifiedDate,
                },
                [DateReferenceOption.EvaluationStartDate]: {
                    label: "Evaluation Start Date",
                    value: DateReferenceOption.EvaluationStartDate,
                },
                [DateReferenceOption.CreatedOnDate]: {
                    label: "Created On Date",
                    value: DateReferenceOption.CreatedOnDate,
                },
            };
        }, [useCustomIds]);

        const enabledReferenceOptions = React.useMemo(
            () => dateReferenceOptions.map((o) => dropDownOptions[o]),
            [dateReferenceOptions, dropDownOptions],
        );

        return (
            <>
                {dateReferenceOptions.length > 0 && (
                    <AcxSelectSingle
                        inputLabel="Date Type"
                        isDisabled={disabled}
                        defaultValue={
                            dropDownOptions[datePickerStore.referenceOption]
                        }
                        id="referenceSelector"
                        options={enabledReferenceOptions}
                        labelField="label"
                        valueField="value"
                        onChange={(opt) => {
                            onChange?.(opt);
                            datePickerStore.setReferenceOption(opt.value);
                        }}
                        menuPortalTarget={menuPortalTarget}
                    />
                )}
            </>
        );
    },
);

export default AcxDateTypeSelector;
